import { ErrorType } from '../../models/HttpError';
import { AppThunkAction } from '../reducers';

import { ContractStageType } from '../../models/Entities/Contracts/ContractStageType';

// actions
import * as Actions from '../actions';

// services
import * as Services from '../../services/ContractStageTypes.Services';

type KnownAction =
    | Actions.ContractStageType.ContractStageTypeGetAllRequestAction
    | Actions.ContractStageType.ContractStageTypeGetAllSuccessAction
    | Actions.ContractStageType.ContractStageTypeGetAllFailureAction
    | Actions.ContractStageType.ContractStageTypeGetByIdRequestAction
    | Actions.ContractStageType.ContractStageTypeGetByIdSuccessAction
    | Actions.ContractStageType.ContractStageTypeGetByIdFailureAction
    | Actions.ContractStageType.ContractStageTypeCreateRequestAction
    | Actions.ContractStageType.ContractStageTypeCreateSuccessAction
    | Actions.ContractStageType.ContractStageTypeCreateFailureAction
    | Actions.ContractStageType.ContractStageTypeUpdateRequestAction
    | Actions.ContractStageType.ContractStageTypeUpdateSuccessAction
    | Actions.ContractStageType.ContractStageTypeUpdateFailureAction
    | Actions.ContractStageType.ContractStageTypeDeleteRequestAction
    | Actions.ContractStageType.ContractStageTypeDeleteSuccessAction
    | Actions.ContractStageType.ContractStageTypeDeleteFailureAction;

export const actionCreators = {
    GetAllContractsStageTypes: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
               
        var state = getState();
        var token: string = '';

        if (state.oidc?.user) {
            token = state.oidc?.user?.access_token;
        } else {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_ALL_FAILURE,
                error: { ErrorCode: 401, ErrorMessage: 'Unauthorized', Errors: [] }
            });
            return;
        }

        dispatch({
            type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_ALL_REQUEST
        });

        Services.GetContractsStageTypes(token)
        .then((contractStages: ContractStageType[]) => {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_ALL_SUCCESS,
                StageTypes: contractStages
            });
        })
        .catch((error: ErrorType) =>
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_ALL_FAILURE,
                error: error
            })
        ); 
    },
    GetContractStageTypeById: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        var state = getState();
        var token: string = '';
        if (state.oidc?.user) {
            token = state.oidc?.user?.access_token;
        } else {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_BY_ID_FAILURE,
                error: { ErrorCode: 401, ErrorMessage: 'Unauthorized', Errors: [] }
            });
            return;
        }
        dispatch({ type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_BY_ID_REQUEST });
        Services.GetContractStageTypeById(id, token)
            .then((stageType: ContractStageType) => {
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS,
                    StageType: stageType
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_GET_BY_ID_FAILURE,
                    error: error
                })
            );
    },
    CreateContractStageType: (data: Partial<ContractStageType>): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        var state = getState();
        var token: string = '';
        if (state.oidc?.user) {
            token = state.oidc?.user?.access_token;
        } else {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_CREATE_FAILURE,
                error: { ErrorCode: 401, ErrorMessage: 'Unauthorized', Errors: [] }
            });
            return;
        }
        dispatch({ type: Actions.ContractStageType.CONTRACTSTAGETYPE_CREATE_REQUEST, StageType: data as ContractStageType });
        Services.CreateContractStageType(data, token)
            .then((stageType: ContractStageType) => {
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_CREATE_SUCCESS,
                    StageType: stageType
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_CREATE_FAILURE,
                    error: error
                })
            );
    },
    UpdateContractStageType: (id: number, data: Partial<ContractStageType>): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        var state = getState();
        var token: string = '';
        if (state.oidc?.user) {
            token = state.oidc?.user?.access_token;
        } else {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_UPDATE_FAILURE,
                error: { ErrorCode: 401, ErrorMessage: 'Unauthorized', Errors: [] }
            });
            return;
        }
        dispatch({ type: Actions.ContractStageType.CONTRACTSTAGETYPE_UPDATE_REQUEST, StageType: data as ContractStageType });
        Services.UpdateContractStageType(id, data, token)
            .then((stageType: ContractStageType) => {
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_UPDATE_SUCCESS,
                    StageType: stageType
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_UPDATE_FAILURE,
                    error: error
                })
            );
    },
    DeleteContractStageType: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        var state = getState();
        var token: string = '';
        if (state.oidc?.user) {
            token = state.oidc?.user?.access_token;
        } else {
            dispatch({
                type: Actions.ContractStageType.CONTRACTSTAGETYPE_DELETE_FAILURE,
                error: { ErrorCode: 401, ErrorMessage: 'Unauthorized', Errors: [] }
            });
            return;
        }
        dispatch({ type: Actions.ContractStageType.CONTRACTSTAGETYPE_DELETE_REQUEST, id });
        Services.DeleteContractStageType(id, token)
            .then(() => {
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_DELETE_SUCCESS,
                    id
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: Actions.ContractStageType.CONTRACTSTAGETYPE_DELETE_FAILURE,
                    error: error
                })
            );
    },
}